import type { ActivityModule } from '../../core/activity';
import { mountCalendar } from './ui';
import levelsData from './levels.json';
import './style.css';

export const calendar: ActivityModule = {
  id: 'calendar',
  title: 'Calendário',
  description: 'Aprenda a ler um calendário: ache datas, dias da semana e meses.',
  ageMin: 7,
  ageMax: 10,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/calendar/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountCalendar,
};
